export interface DropDownModel {
    id: string;
    displayName: string;
}

export interface DropDownWithLabelModel {
    label: string;
    dropDown: DropDownModel[];
}

export enum CountId {
    zero = "0",
    one = "1",
    two = "2",
    three = "3",
    four = "4",
    five = "5",
    six = "6",
    seven = "7",
    eight = "8"
}
